export const META_PIXEL_ID = '1410907521157089';

const LEAD_LABELS = [
  'start your free 14-day trial',
  'book a quick call',
];

export function isLeadLabel(text) {
  const label = String(text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  return LEAD_LABELS.some((item) => label.includes(item));
}

export function ensureMetaPixel(win) {
  if (!win || typeof win.fbq === 'function') return;
  const doc = win.document;
  if (!doc) return;
  const fbq = function pixel() {
    if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
    else fbq.queue.push(arguments);
  };
  if (!win._fbq) win._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  win.fbq = fbq;
  const script = doc.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const first = doc.getElementsByTagName('script')[0];
  if (first && first.parentNode) first.parentNode.insertBefore(script, first);
  else if (doc.head) doc.head.appendChild(script);
}

const inited = new Set();

export function initMetaPixel(pixelId, win) {
  const id = String(pixelId || '').trim();
  if (!win || !id) return;
  ensureMetaPixel(win);
  if (typeof win.fbq !== 'function' || inited.has(id)) return;
  inited.add(id);
  win.fbq('init', id);
}

export function trackMetaPageView(win) {
  if (!win || typeof win.fbq !== 'function') return;
  win.fbq('track', 'PageView');
}

export function trackMetaEvent(win, eventName, params, options) {
  if (!win || typeof win.fbq !== 'function' || !eventName) return;
  if (options) win.fbq('track', eventName, params || {}, options);
  else win.fbq('track', eventName, params || {});
}
